export const UPDATE_RESIZE_VALUES = 'update_resize_values'
export const TOGGLE_RESIZE_RATIO_LOCK = 'toggle_resize_ratio_lock'
export const SET_RESIZE_CHANGED_STATUS = 'set_resize_changed_status'
export const SET_RESIZE_MODAL = 'set_resize_modal'
export const SET_RESIZE_REDIRECT = 'set_resize_redirect'
